export const AppNameBeta = 'Project Neo (Beta)'
